<script>
import RequestAgentKitDialog from "../../common/requestAgentKitDialog.vue";
import {redirectToAgentLogin} from "../../../helpers/routerHelper";
import {STATES} from "../../../helpers/constantsHelper";
import {mapActions} from "vuex";
import {regexPatterns} from "../../../utils/utils";

export default {
  name: "agentRegistrationSection1",
  data() {
    return {
      loading: false,
      requestAgentDialogVisible: false,
      requestAgentForm: {
        firstName: "",
        lastName: "",
        companyName: "",
        state: "",
        email: "",
        phoneNumber: "",
        message: ""
      },
      rules: {
        firstName: {
          required: true,
          message: "Please enter your first name",
          trigger: "blur"
        },
        lastName: {
          required: true,
          message: "Please enter your last name",
          trigger: "blur"
        },
        companyName: {
          required: true,
          message: "Please enter your company name",
          trigger: "blur"
        },
        state: {
          required: true,
          message: "Please select your state",
          trigger: ["blur"]
        },
        email: {
          required: true,
          message: "Please enter a correct email",
          trigger: "blur",
          pattern: regexPatterns.email
        },
        phoneNumber: {
          required: true,
          message: "Please enter your phone number",
          trigger: "blur",
          pattern: regexPatterns.phoneNumber
        },
        // message: {
        //   required: true,
        //   message: "Please enter your message",
        //   trigger: "blur"
        // }
      }
    };
  },
  methods: {
    ...mapActions("request", ["sendRequestAgentKitEmail"]),
    redirectToAgentLogin,
    requestAgentKit() {
      this.requestAgentDialogVisible = true;
    },
    STATES() {
      return STATES
    },
    validateField(field) {
      this.$refs.requestAgentForm.validateField(field);
    },
    onSubmit(formName) {
      if (this.loading) return;
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.loading) return;
          this.loading = true;
          this.sendRequestAgentKitEmail({
            params: {
              data: {
                firstName: this.requestAgentForm.firstName,
                lastName: this.requestAgentForm.lastName,
                companyName: this.requestAgentForm.companyName,
                state: this.requestAgentForm.state,
                email: this.requestAgentForm.email,
                phoneNumber: this.requestAgentForm.phoneNumber,
                message: this.requestAgentForm.message ? this.requestAgentForm.message : "N/A",
              },
            },
            callback: this.agentKitEmailCallback
          });
        } else {
          return false;
        }
      });
    },
    agentKitEmailCallback(res) {
      this.loading = false;
      if (res.data.code == 0) {
        this.$notify({
          title: 'Success',
          message: 'Agent kit request sent successfully',
          type: 'success',
          customClass: 'my-custom-notify',
          duration: 6000,
        });
        this.clearRequestAgentForm();
      } else {
        this.$box.alert("", res.data.message, "error");
      }
    },
    clearRequestAgentForm() {
      this.requestAgentForm = {
        firstName: "",
        lastName: "",
        companyName: "",
        state: "",
        email: "",
        phoneNumber: "",
        message: ""
      };
    }
  },
  components: {RequestAgentKitDialog}
}
</script>

<template>
  <div class="page-outer-wrapper">
    <el-row class="main-content">
      <el-col :span="24"
                 class="left-content">

        <div class="content-wrapper">
          <h2 class="title">Feature Your Projects on the Real Estate</h2>
          <h3 class="subtitle">Platform Designed for Off-the-plan</h3>

          <p class="description">
            Discover a community tailored exclusively for real estate agents specialising in off-the-plan and newly built properties. UNIFI connects you with a targeted audience and provides valuable resources to assist you in selling off-the-plan in the competitive property market. Ready to elevate your business? Click below to request our Agent Kit and learn how to get started with UNIFI today!
          </p>
          <el-card>
            <el-row>
              <el-col :span="24">
                <el-divider> <span style="font-weight: 600; font-size: 14px">Request Agent Kit</span> </el-divider>
              </el-col>
            </el-row>
            <el-form
              ref="requestAgentForm"
              :model="requestAgentForm"
              :rules="rules"
              label-position="top"
              label-width="100px"
              @submit.native.prevent
              style="font-family: DINosaur-a, sans-serif;">
              <el-row>
                <el-col :span="24">
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="First Name" prop="firstName">
                        <el-input
                          v-model="requestAgentForm.firstName"
                          maxlength="50"
                          placeholder="Your first name"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="Last Name" prop="lastName">
                        <el-input
                          v-model="requestAgentForm.lastName"
                          maxlength="100"
                          placeholder="Your last name"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="Company" prop="companyName">
                        <el-input
                          v-model="requestAgentForm.companyName"
                          maxlength="100"
                          placeholder="Agency/Developer name"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="Location" prop="state">
                        <el-select v-model="requestAgentForm.state" @change="validateField('state')" clearable filterable placeholder="Select a state" style="width: 100%">
                          <el-option
                            v-for="item in STATES()"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="Email" prop="email">
                        <el-input
                          v-model="requestAgentForm.email"
                          maxlength="100"
                          placeholder="Your email"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="Phone Number" prop="phoneNumber">
                        <el-input
                          v-model="requestAgentForm.phoneNumber"
                          maxlength="20"
                          placeholder="Your phone number"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="Message" prop="message">
                        <el-input
                          type="textarea"
                          v-model="requestAgentForm.message"
                          maxlength="1000"
                          show-word-limit
                          placeholder="Message"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <el-form-item style="text-align:center">
                        <el-button class="join-btn" @click="onSubmit('requestAgentForm')">
                          REQUEST AGENT KIT
                          <i v-if="loading" class="el-icon-loading"></i>
                        </el-button>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-col>
              </el-row>
            </el-form>
          </el-card>

          <el-row>
<!--            <el-col   :span="12">-->
<!--              <el-button-->
<!--                type="primary"-->
<!--                size="large"-->
<!--                class="join-btn"-->
<!--                @click="requestAgentKit()"-->
<!--              >-->
<!--                REQUEST AGENT KIT-->
<!--              </el-button>-->
<!--            </el-col>-->
            <el-col :span="24">
              <el-divider> <span style="font-size: 12px; display: flex; text-align: center">Already have an agent account?</span> </el-divider>
              <el-button
                type="primary"
                size="large"
                class="sign-in-btn"
                @click="redirectToAgentLogin"
              >
                SIGN IN
              </el-button>
            </el-col>
          </el-row>
        </div>
      </el-col>

      <el-col :span="24" class="right-content">
        <div class="image-wrapper">
          <img class="background-image" src="../../../assets/agent-reg-background.png" alt="">
        </div>
      </el-col>
    </el-row>
<!--    <request-agent-kit-dialog v-if="requestAgentDialogVisible" :request-agent-dialog-visible="requestAgentDialogVisible" @onClose="requestAgentDialogVisible = false" />-->

  </div>

</template>

<style scoped lang="scss">
.main-content {
  display: flex;
  min-height: 60%;
}

.left-content {
  padding: 40px 60px;
  display: flex;
  flex-direction: column;
}
.content-wrapper {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.title {
  color: #003333;
  font-size: 18px;
  line-height: 1;
  font-weight: 700;
  margin-bottom: 20px;
}

.subtitle {
  color: #003333;
  font-size: 18px;
  font-weight: 600;
  line-height: 1;
  margin-bottom: 30px;

}

.description {
  color: #003333;
  font-size: 14px;
  margin-bottom: 40px;
  line-height: 1.5;
}

.join-btn {
  width: 100%;
  background-color: #003333;
  border-color: #003333;
  border-radius: 5px;
  padding: 10px 0;
  height: max-content;
  margin-top: 10px;
  font: 500 14px DINosaur-a, sans-serif;
  color: #ffffff;
}
.sign-in-btn {
  width: 100%;
  background-color: #ffffff;
  border-color: #003333;
  border-radius: 5px;
  padding: 10px 0;
  height: max-content;
  font: 500 14px DINosaur-a, sans-serif;
  color: #003333;
}

.right-content {
  position: relative;
}

.image-wrapper{
  width: 90%;

}
.background-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.el-card /deep/ .el-card__body {
  padding: 10px !important;
}

.el-form--label-top /deep/ .el-form-item__label {
  padding: 0 !important;
  line-height: normal !important;
}

.el-divider__text {
  padding: 0 10px !important;
}

@media (max-width: 768px) {
  .main-content {
    flex-direction: column;
  }
  .left-content {
    padding: 30px;
  }
  .right-content {
    min-height: 300px;
    display: flex;
    justify-content: center;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/register/agentRegistration/agentRegistrationSection1.vue